<template>
  <!--询盘服务-->
  <div class="ab-scrm">
    <div class="ab-scrm-header flex-row">
      <div class="ab-banner-header flex-col">
        <MainNav />
        <div class="ab-banner-info warp">
          <div class="ab-banner-name fontsize32">
            <span>综合服务</span> <em></em>
          </div>
          <div class="ab-banner-name fontsize50">
            <span>一站式智能营销管理平台（SCRM）</span> <em></em>
          </div>
          <div class="ab-banner-desc fontsize20">
            <span>企业认证即可免费试用</span>
          </div>
          <div class="ab-banner-btn">
            <Abbutton
              ><a
                @click="showModal"
                data-source="p"
                onmouseover="linkDataSource(this)"
                a-type="register"
                target="_blank"
                >立即试用</a
              ></Abbutton
            >
          </div>
        </div>
      </div>
    </div>

    <div class="warp ab-scrm-arrangement ">
      <AbBlock title="平台结构部署" subTitle="运营与管理集一体化">
        <div class="clearfix ab-scrm-arrangement-main">
          <a-row :gutter="[40, 0]">
            <a-col
              :xs="18"
              :xl="18"
              class="ab-scrm-container-left"
              style="padding-top: 15px;margin-bottom: 15px;"
            >
              <!-- 数据驾驶舱 -->
              <a-row style="height: 100%;">
                <a-col :xs="24" :xl="24" class="noPadding marginBottom">
                  <!-- 数据驾驶舱 -->
                  <a-row :gutter="[0, 30]">
                    <a-col :xs="4" :xl="4" class="noPadding">
                      <div class="ad-scrm-blue fontsize32">
                        <span>数据驾驶舱</span>
                      </div>
                    </a-col>
                    <a-col :xs="20" :xl="20" class="noPadding">
                      <div class="ad-scrm-blue-right">
                        <a-row :gutter="[20, 30]">
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <div class="fontsize20">
                                数据探索
                              </div>
                              <ul>
                                <li><span>业务关键指标</span></li>
                                <li><span>行业趋势预测</span></li>
                                <li><span>可视化报告</span></li>
                              </ul>
                            </div>
                          </a-col>
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <div class="fontsize20">
                                数据场景
                              </div>
                              <ul>
                                <li><span>渠道数据</span></li>
                                <li><span>业务数据</span></li>
                                <li><span>营销事件</span></li>
                              </ul>
                            </div>
                          </a-col>
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <div class="fontsize20">
                                数据管理
                              </div>
                              <ul>
                                <li><span>交易轨迹数据</span></li>
                                <li><span>客户画像数据</span></li>
                                <li><span>客户关系图谱</span></li>
                              </ul>
                            </div>
                          </a-col>
                        </a-row>
                      </div>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :xs="24" :xl="24" class="noPadding marginBottom">
                  <!-- 基础应用 -->
                  <a-row :gutter="[0, 30]">
                    <a-col :xs="4" :xl="4" class="noPadding">
                      <div class="ad-scrm-blue fontsize32 ad-scrm-blue-height">
                        <span>基础应用</span>
                      </div>
                    </a-col>
                    <a-col :xs="20" :xl="20" class="noPadding">
                      <div class="ad-scrm-blue-right ad-scrm-blue-height">
                        <a-row :gutter="[20, 30]">
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main ">
                              <ul>
                                <li><span>账号管理</span></li>
                                <li><span>推荐管理</span></li>
                                <li><span>获客管理</span></li>
                              </ul>
                            </div>
                          </a-col>
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <ul>
                                <li><span>线索管理</span></li>
                                <li><span>日程提醒</span></li>
                                <li><span>角色管理</span></li>
                              </ul>
                            </div>
                          </a-col>
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <ul>
                                <li><span>销售资料</span></li>
                                <li><span>空间管理</span></li>
                                <li><span>统计报告</span></li>
                              </ul>
                            </div>
                          </a-col>
                        </a-row>
                      </div>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col
                  :xs="24"
                  :xl="24"
                  class="noPadding"
                  style="position: absolute;bottom: 0px;"
                >
                  <!-- 基础应用 -->
                  <!-- 业务模型 -->
                  <a-row :gutter="[0, 30]">
                    <a-col
                      :xs="4"
                      :xl="4"
                      class="noPadding"
                      style="padding-bottom: 0px !important;"
                    >
                      <div class="ad-scrm-blue fontsize32">
                        <span>业务模型</span>
                      </div>
                    </a-col>
                    <a-col
                      :xs="20"
                      :xl="20"
                      class="noPadding"
                      style="padding-bottom: 0px !important;"
                    >
                      <div class="ad-scrm-blue-right">
                        <a-row :gutter="[20, 30]">
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <div class="fontsize20">
                                数字模型
                              </div>
                              <ul>
                                <li><span>五维模型</span></li>
                                <li><span>校验查证</span></li>
                                <li><span>异常预警</span></li>
                              </ul>
                            </div>
                          </a-col>
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <div class="fontsize20">
                                数据资产
                              </div>
                              <ul>
                                <li><span>基础标签</span></li>
                                <li><span>SQL标签</span></li>
                                <li><span>分类定义</span></li>
                              </ul>
                            </div>
                          </a-col>
                          <a-col :xs="8" :xl="8">
                            <div class="ad-scrm-blue-main">
                              <div class="fontsize20">
                                任务管理
                              </div>
                              <ul>
                                <li><span>追踪监控</span></li>
                                <li><span>有效触达</span></li>
                                <li><span>效果量化</span></li>
                              </ul>
                            </div>
                          </a-col>
                        </a-row>
                      </div>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <!-- 业务模型 -->
            </a-col>
            <a-col :xs="6" :xl="6" class="small-ul">
              <div class="ad-scrm-r-blue fontsize32">
                数据应用
              </div>
              <div class="ad-scrm-r-bottom">
                <!-- 数据挖掘 -->
                <a-row :gutter="[0, 20]">
                  <a-col :xl="24" style="padding-bottom: 5px;">
                    <div class="ad-scrm-blue-main">
                      <div class="fontsize20">
                        任务管理
                      </div>
                      <ul>
                        <li><span>追踪监控</span></li>
                        <li><span>有效触达</span></li>
                        <li><span>效果量化</span></li>
                      </ul>
                    </div>
                  </a-col>
                  <a-col
                    :xl="24"
                    class="bottom-container"
                    style="padding-bottom: 5px;"
                  >
                    <div class="ad-scrm-blue-main">
                      <div class="fontsize20">
                        数据分析
                      </div>
                      <ul>
                        <li><span>漏斗分析</span></li>
                        <li><span>转化分析</span></li>
                        <li><span>目标分析</span></li>
                        <li><span>效果分析</span></li>
                      </ul>
                    </div>
                  </a-col>
                  <a-col :xl="24" class="bottom-container">
                    <div class="ad-scrm-blue-main">
                      <div class="fontsize20">
                        数据监控
                      </div>
                      <ul>
                        <li><span>风险预警</span></li>
                        <li><span>行为动态</span></li>
                        <li><span>事件追踪</span></li>
                        <li><span>指标监控</span></li>
                      </ul>
                    </div>
                  </a-col>
                </a-row>
                <!-- 数据挖掘 -->
              </div>
            </a-col>
          </a-row>

          <!-- 资源中心 -->
          <a-row :gutter="[0, 30]">
            <a-col :xs="3" :xl="3" class="ad-scrm-zyzx-w">
              <div class="ad-scrm-blue fontsize32"><span>资源中心</span></div>
            </a-col>
            <a-col :xs="21" :xl="21">
              <div class="ad-scrm-blue-right">
                <a-row :gutter="[20, 0]" class="ad-scrm-zyzx">
                  <a-col :xs="6" :xl="6">
                    <div class="ad-scrm-blue-main">
                      <div class="ad-scrm-blue-main">
                        <div class="fontsize20">
                          需求管理
                        </div>
                        <ul>
                          <li><span>定制需求</span></li>
                          <li><span>派生需求</span></li>
                          <li><span>触点升级</span></li>
                        </ul>
                      </div>
                    </div>
                  </a-col>
                  <a-col :xs="12" :xl="12">
                    <div class="ad-scrm-blue-main">
                      <div class="fontsize20">
                        应用管理
                      </div>
                      <a-row class="ad-scrm-zyzx-p">
                        <a-col :xs="12" :xl="12">
                          <ul>
                            <li><span>营销决策</span></li>
                            <li><span>客户管理</span></li>
                            <li><span>智能营销</span></li>
                          </ul>
                        </a-col>
                        <a-col :xs="12" :xl="12">
                          <ul>
                            <li><span>营销邮件</span></li>
                            <li><span>全球电话</span></li>
                            <li><span>即时通讯</span></li>
                          </ul>
                        </a-col>
                      </a-row>
                    </div>
                  </a-col>
                  <a-col :xs="5" :xl="5">
                    <div class="ad-scrm-blue-main">
                      <div class="ad-scrm-blue-main">
                        <div class="fontsize20">
                          运营管理
                        </div>
                        <ul>
                          <li><span>用户运营</span></li>
                          <li><span>数据运营</span></li>
                          <li><span>渠道运营</span></li>
                        </ul>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </a-row>
          <!-- 资源中心 -->
          <!-- 服务 -->
          <a-row :gutter="[0, 30]">
            <div class="ad-scrm-fw">
              <a-col :xs="3" :xl="3">
                <div class="ad-scrm-blue fontsize32"><span>服务</span></div>
              </a-col>
              <a-col :xs="21" :xl="21">
                <div class="ad-scrm-blue-right">
                  <a-row :gutter="[20, 0]">
                    <a-col :xs="6" :xl="6">
                      <div class="ad-scrm-blue-main ">
                        <ul>
                          <li><span>优化迭代升级</span></li>
                        </ul>
                      </div>
                    </a-col>
                    <a-col :xs="6" :xl="6">
                      <div class="ad-scrm-blue-main ">
                        <ul>
                          <li><span>风险预警监控</span></li>
                        </ul>
                      </div>
                    </a-col>
                    <a-col :xs="6" :xl="6">
                      <div class="ad-scrm-blue-main ">
                        <ul>
                          <li><span>技术运维服务</span></li>
                        </ul>
                      </div>
                    </a-col>
                    <a-col :xs="6" :xl="6">
                      <div class="ad-scrm-blue-main ">
                        <ul>
                          <li><span>安全存储保障</span></li>
                        </ul>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </a-col>
            </div>
          </a-row>
          <!-- 服务 -->
        </div>
      </AbBlock>
    </div>

    <div class="ad-scrm-tabs">
      <div class="warp">
        <a-tabs>
          <a-tab-pane key="1" tab="外贸资讯">
            <!-- 外贸资讯 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_1.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    优质的贸易资讯与交流平台 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>实时推送热点动态，网罗贸易资讯</li>
                      <li><i></i>轻量化学习社区，更多出海营销干货</li>
                      <li><i></i>为国际贸易人打造超实用的交流社群</li>
                      <li><i></i>提供更多更优势的综合跨境贸易红利</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 外贸资讯 -->
          </a-tab-pane>
          <a-tab-pane key="2" tab="营销决策">
            <!-- 营销决策 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_2.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    为科学决策提供更可靠的依据 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>数据洞察更清晰，业务决策更容易</li>
                      <li><i></i>基于多维度数据分析，构建数字模型</li>
                      <li><i></i>满足从营销、销售到服务的业务分析需求</li>
                      <li><i></i>深度挖掘数据价值，可视化数据一览无余</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 营销决策 -->
          </a-tab-pane>
          <a-tab-pane key="3" tab="智能营销">
            <!-- 智能营销 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_3.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    快速筛选智能培育优质线索 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>自动化营销画布搭建，精准锁定目标客户</li>
                      <li><i></i>基于数据应用，营销流程进行自动化配置</li>
                      <li><i></i>动态生成线索全景画像，构建数字化资产</li>
                      <li><i></i>客户全旅程跟踪监控，智能推荐匹配线索</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 智能营销 -->
          </a-tab-pane>
          <a-tab-pane key="4" tab="客户管理">
            <!-- 客户管理 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_4.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    从线索到成单客户全生命周期管理 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>多渠道线索聚合式管理，提升线索转化率</li>
                      <li><i></i>待办事项提醒，同步各渠道跟进触点</li>
                      <li><i></i>精细的全面客户管理，加速商机转化</li>
                      <li><i></i>可视化销售数据看板，洞察销售能力</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 客户管理 -->
          </a-tab-pane>
          <a-tab-pane key="5" tab="营销邮件">
            <!-- 营销邮件 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_5.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    超好用的企业级外贸营销邮件 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>一键邮件营销，快速批量触达目标客户</li>
                      <li><i></i>支持自己创建各种模板，彰显企业形象</li>
                      <li><i></i>每一封邮件的收发及浏览记录后台有迹可查</li>
                      <li><i></i>全渠道邮件推广超低价，送达率超过99.9%</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 营销邮件 -->
          </a-tab-pane>
          <a-tab-pane key="6" tab="全球电话">
            <!-- 全球电话 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_6.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    全球智能云端外呼系统 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>7000+超低资费运营商线路，收费简单透明</li>
                      <li><i></i>多终端拨打灵活切换，通话录音自动保存</li>
                      <li><i></i>去电号码备注，极大提高接听、回拨几率</li>
                      <li><i></i>通话音质清晰稳定，自主切换优质运营线路</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 全球电话 -->
          </a-tab-pane>
          <a-tab-pane key="7" tab="即时通讯">
            <!-- 即时通讯 -->
            <div class="tab-content">
              <div class="content-desc flex-row">
                <div class="desc-pics">
                  <img src="~@/assets/product/scrm_7.jpg" alt="" />
                </div>
                <div class="desc-info">
                  <div class="desc-title fontsize40">
                    WhatsApp-高效的沟通触达工具 <span></span>
                  </div>
                  <div class="desc-long-title fontsize26"></div>
                  <div class="desc-words fontsize18">
                    <ul>
                      <li><i></i>号码验证、在线翻译有效降低沟通难度</li>
                      <li><i></i>沟通记录同步，实时跟踪记录触发轨迹</li>
                      <li><i></i>自动建档及身份验证，提高沟通协助效率</li>
                      <li><i></i>WhatsApp同CRM双向关联，在线收询盘</li>
                    </ul>
                  </div>
                  <div class="ab-banner-btn fl">
                    <Abbutton
                      ><a
                        @click="showModal"
                        data-source="p"
                        onmouseover="linkDataSource(this)"
                        a-type="register"
                        target="_blank"
                        >立即试用</a
                      ></Abbutton
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 即时通讯 -->
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <!--服务列表价格清单-->
    <ServerList></ServerList>

    <!--问题列表-->
    <!-- <QuestionList></QuestionList> -->
    <QuestionList v-bind="questionData"></QuestionList>
    <!--已服务列表-->
    <CustomerList></CustomerList>
    <FooterBanner></FooterBanner>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import MainNav from "@/components/MainNav.vue";
import Abbutton from "@/components/Abbutton.vue";
import AbBlock from "@/components/AbBlock.vue";
import ServerList from "./Scrm/ServerList.vue";
import QuestionList from "@/components/QuestionList.vue";
import CustomerList from "@/components/CustomerList.vue";
import FooterBanner from "@/components/FooterBanner.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import metaInfo from "@/metaInfo";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  metaInfo: metaInfo["scrm"],
  components: {
    MainNav,
    Abbutton,
    AbBlock,
    ServerList,
    QuestionList,
    CustomerList,
    FooterBanner,
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
      questionData: {
        blockTitle: "常见问题",
        blockSubTitle: "帮助客户快速解决问题",
        listData: [
          {
            q: "注册认证后的CRM是免费的吗？",
            a:
              "通过企业认证后的CRM是可以免费使用，目前免费开放的功能足以支持SOHO类型的外贸人使用，若免费版本不能满足业务需求，可选购基础版及以上版本，随着CRM的不断优化迭代，未来将还会陆续开放更多的免费功能。",
          },
          {
            q: "AB客CRM与市面其他外贸CRM有什么不同？",
            a:
              "AB客CRM是基于外贸全流程业务而打造的智能数字化CRM系统，功能模块贯穿整个外贸业务体系，包含外贸资讯、客户管理与跟进、营销决策、智能营销以及触达全球用户的营销邮件、全球电话、即时通讯等数款产品的集成，致力于为外贸人提供一款更懂外贸的智能生态系统。",
          },
          {
            q: "购买的CRM，因业务持续上升，现有资源不足怎么办？",
            a:
              "不同版本的CRM所配置的资源是不同的，因业务量上升或者公司业务调整而导致资源不足，可单独选购所需的资源包拓展现有资源，也可以通过版本升级拓展为高级资源，详情可咨询在线客服。",
          },
          {
            q: "CRM可以一次性买断吗？",
            a:
              "目前推出的CRM最高版本为“企业尊贵版”支持用户一次性买断，其特权主要体现在账号部分资源无限制添加，营销邮件、全球电话每年赠送相应的资源，后续开发上线的付费产品将优先体验参与公测。",
          },
        ],
      },
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass">
.ad-scrm-tabs{
  background:#F7F8FC;
  margin-top:80px;

     .desc-pics{
      padding-right: 107px;
      }
    .desc-title{
      height: 55px;
      color: #333646;
      line-height: 55px;

      span{
        width: 100px;
        height: 4px;
        background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
        display: block;
        margin-top:30px;
      }
    }
    .desc-long-title{

      font-family: AlibabaPuHuiTiM;
      color: #333646;
      line-height: 30px;
      padding-top: 75px;

    }
    .ab-banner-btn{
      margin-top:34px;
    }
    .desc-words{
      li{
        padding:9px 0px;
        color:rgba(51,51,51,0.8);
        i{
          background:#198BFF;
          border-radius:50px;
          height:8px;
          width:8px;position: relative;
          top: -2px;
          display: inline-block;margin-right:12px;
        }
      }
      padding-top:3px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: rgba(51,51,51,0.8);
      line-height: 30px;
    }
  .ant-tabs-bar{
  border-bottom: 4px solid #ececec;
  padding-top:30px;
  }
  .ant-tabs-nav .ant-tabs-tab{
    font-size:20px;
    line-height: 40px;
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: #2B68FF !important
}
.ant-tabs-nav-scroll,.ant-tabs-nav-wrap,.ant-tabs-nav-container{
  overflow:inherit
}
.tab-content{
  padding:60px 0px 50px 15px ;
}
.ant-tabs-ink-bar{
  height:4px;
  background:#1d84fd !important;
  bottom:-2px;

}

}
.ab-scrm .ab-question .q-list .q-item .q-block{
  height:7rem;
}
.ad-scrm-zyzx-w.ant-col-xl-3{
  width:200px;
}
.ad-scrm-blue-main{
  text-align:center;
  width:100%;
  ul{
    span{
      font-size:18px;
      display: block;
      padding:9px 0px;
    }
    padding:11px 0px;
  }
  &:hover {
    box-shadow: 0px 4px 8px 0px rgba(43,104,255,0.2000);
  }
  &:hover .fontsize20{
    color: #2B68FF;
  }
  .fontsize20{
    line-height: 60px;
    background: #F0F3F9;

  }
    border-radius: 8px;
    border: 1px solid #D6EAFF;

  }

.ab-scrm-arrangement{
  .ad-scrm-fw{
    display: flex;
    .ad-scrm-blue-main{
      ul a{
        padding:19px 0px;
      }
    }
    .ad-scrm-blue-right{
      height:150px;
      padding-left:30px;
      padding-right:40px;
    }
      .ant-col-xl-3{
      width:200px;
      flex: none;
      display: flex;
    }
    .ad-scrm-blue{
      height:150px;
      width: 100%;
    }
  }
  .ad-scrm-zyzx{
    .ad-scrm-zyzx-p{
      padding:0px 100px;
    }
     display: flex;
    .ant-col-xl-12{
      flex-grow: 1; justify-content: center;   display: flex;
    }
    .ant-col-xl-6{
      width:320px;
      flex: none;    display: flex;
    }
    .ant-col-xl-5{
      width:311px;
      margin-right:10px;
      flex: none;    display: flex;
    }
  }
  .ad-scrm-r-bottom{
  height: 775px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .ad-scrm-blue-main ul li a{
      padding:4px 0px
    }
    padding:20px 30px;
   border-radius: 0px 0px 8px 8px;
border: 1px solid #D6EAFF;
  }
  .ad-scrm-r-blue{
    line-height: 97px;
    height: 97px;
    text-align:center;
    color:#fff;
background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
border-radius: 8px 8px 0px 0px;
  }
  .ad-scrm-blue-right{
    border:1px solid #D6EAFF;
    text-align:center;
    border-left:none;
    padding:30px;
    height:280px;
     border-radius: 0px 8px 8px 0px;
  }
  .ab-scrm-arrangement-main{
    padding-top:63px;
  }
  .ab-scrm-container-left {
    height: 870px;
    .noPadding {
      padding-bottom: 0px !important;
      padding-top: 0px !important;
    }
    .marginBottom {
      margin-bottom: 70px;
    }
  }
  .ad-scrm-blue-height.ad-scrm-blue,.ad-scrm-blue-right.ad-scrm-blue-height{
    height:220px;
   }
  .ad-scrm-blue{
    background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
    border-radius: 8px 0px 0px 8px;
    text-align:center;
    position: relative;
    color:#fff;
    height: 280px;
    display: flex;
    font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
    span{
     writing-mode: tb-rl;
    -webkit-writing-mode: vertical-rl;
    letter-spacing: 10px;
    justify-content: center;
    align-items: center;
    display: flex;
    flex: 1;
    }
  }
  padding-top:52px;
}
.ab-scrm-header {
  height:620px;
  background: url('~@/assets/images/询盘服务_banner.jpg') 100% no-repeat;
  width: 100%;
  background-size: cover;
}
.small-ul {
height: 870px;
  .bottom-container .ad-scrm-blue-main {
  /*height: 220px;*/
    ul span {
      padding: 4.35px 0;
    }
  }
}
.ab-banner-header {
  width: 100%;
  height: 100%;

  .ab-banner-info{
    padding-top:84px;
    padding-left:145px;
    .ab-banner-name.fontsize32,.ab-banner-name.fontsize50{
      span{
         z-index: 2;
         position: relative
      }
      em{
        width: 151px;
height: 10px;    display: block;
background: linear-gradient(90deg, #FFAEAE 0%, rgba(255,174,174,0) 100%);
position:absolute;    bottom: 16px;
    z-index: 1;    left: -3px;
      }
    }
    .ab-banner-name.fontsize50  em{
       bottom: 10px;
    }
    .ab-banner-name{
      position: relative;
      height: 69px;
      font-family: AlibabaPuHuiTiM;
      color: #333646;
      line-height: 69px;
    }

    .ab-banner-desc{
      span{
        &:hover{
           background: rgba(255,255,255,0.7);
        }
        padding:0px 15px;
        line-height: 36px;
        text-align:center;
        font-size:18px;
        color:#2B68FF;
        margin-right:10px;
        display: inline-block;
        background: rgba(255,255,255,0.3);

      }
      width: 549px;
      margin-bottom:45px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;
      color: rgba(51,51,51,0.4);
      line-height: 36px;
      padding-top: 27px;
    }
    .ab-banner-btn{
      width:200px;
    }
  }
}
</style>
